// @ts-expect-error - TS2305 - Module '"monet"' has no exported member 'MaybeType'.
import { Maybe, type MaybeType } from 'monet';
import type { SubmitStatus } from '@atlassian/jira-servicedesk-common/src/ui/components/submit-button/model.tsx';
import type { ProjectRunAsUser } from '../../../model';
import type { State } from '../../types';
import type { RunAsUserUIState } from '../../ui/run-as-user/types';
import { getUI, maybeProjectRunAsUserSettings } from '../base';

export const maybeRunAsUser = (state: State): MaybeType<ProjectRunAsUser> =>
	maybeProjectRunAsUserSettings(state)
		// @ts-expect-error - TS7006 - Parameter 'settings' implicitly has an 'any' type.
		.flatMap((settings) => Maybe.fromNull(settings.config))
		// @ts-expect-error - TS7006 - Parameter 'config' implicitly has an 'any' type.
		.map((config) => config.user);

export const isRunAsUserInvalid = (state: State): boolean =>
	maybeRunAsUser(state)
		// @ts-expect-error - TS7006 - Parameter 'runAsUser' implicitly has an 'any' type.
		.map((runAsUser) => !runAsUser.isValid)
		.orSome(true);

const getRunAsUserUIState = (state: State): RunAsUserUIState => getUI(state).runAsUser;

export const runAsUserDialogIsOpen = (state: State) => getRunAsUserUIState(state).showDialog;

export const misconfiguredRunAsUserDialogIsOpen = (state: State) =>
	getRunAsUserUIState(state).showMisconfiguredDialog;

export const getRunAsUserSaveError = (state: State): string | null =>
	getRunAsUserUIState(state).saveError;

export const getRunAsUserSubmitStatus = (state: State): SubmitStatus =>
	getRunAsUserUIState(state).submitStatus;
